module.exports = __webpack_public_path__ + "img/制御工学6_8.916695d7.png";